import React from 'react';
import './SecurityCheckPageComponent.less';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import SecurityCheckComponent from '../SecurityCheckComponent/SecurityCheckComponent';

class SecurityCheckPageComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            errorTitle: ''
        };
    }
    clearAlert() {
        this.setState({error: '', errorTitle: ''});
    }

    handleError = (error, errorTitle) => {
        this.setState({error, errorTitle});
    };

    render() {
        let cardContent = (
            <SecurityCheckComponent
                handleError={this.handleError}
                {...this.props}
            />
        );
        return (
            <>
                <HeaderSectionComponent title={this.props.lingua.read('lex.header.owner')} subtitle={this.props.lingua.read('lex.header.owner.subtitle')} />
                <CalloutCardComponent content = {cardContent} error={this.state.error} errorTitle={this.state.errorTitle} clearAlert={this.clearAlert}/>
                <TandCComponent lingua={this.props.lingua} multiUserEnabled={this.props.multiUserEnabled}/>
            </>
        );
    }
}

export default SecurityCheckPageComponent;
